import { render, staticRenderFns } from "./studentIntro.vue?vue&type=template&id=75172bf2&scoped=true&"
import script from "./studentIntro.vue?vue&type=script&lang=js&"
export * from "./studentIntro.vue?vue&type=script&lang=js&"
import style0 from "./studentIntro.scss?vue&type=style&index=0&id=75172bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75172bf2",
  null
  
)

export default component.exports